/**
 * List of vendors that can self-schedule
 */

export default [
  'FNPO@celebritypinkusa.com',
  'americanbazi@gmail.com',
  'karla@beardanceclothing.com',
  'david@blueplt.com',
  'jack@caperobbin.com',
  'cs@hellomiss.com',
  'alex@cherrymellow.com',
  'plproduction@civilclothing.com',
  'codigousa@hotmail.com',
  'sales@hotndelish.com',
  'gonzalo@houseofdnm.com',
  'info@jacobies.com',
  'sam@heartandhips.com',
  'stacyc@jpo.com',
  'KEVINMISSAVENUE@GMAIL.COM',
  'shirley@wishforfallingstar.com',
  'bellausa1233@gmail.com',
  'Adamcello27@yahoo.com',
  'joycechong@hyfve.com',
  'tim@legendfootwear.com',
  'denise.m@machifootwear.com',
  'JERRI@ORCHIDLOVE.COM',
  'betterbeinc@hotmail.com',
  'carlo@e8thgroup.com',
  'Donato.Tenore@bravado.com',
  'LORY@SPDMFG.COM',
  'andy.zhang@banjulusa.com',
  'sarah.bostwick+today@fashionnova.com',
  'sarah.bostwick+ns@fashionnova.com',
  'sarah.bostwick+test@fashionnova.com',
  'mayra.g+vendor@fashionnova.com',
  'nathan.spanier+complete-vendor@fashionnova.com',
  // Staging emails for testing
  'tashi.bagril+importer1024@fashionnova.com',
  'henrique.massmann+hmimporter3@fashionnova.com',
  'baptiste.cayrier+testbaptiste1409@fashionnova.com',
];
